<template>
  <div>
    <el-form
      ref="form"
      :model="form"
      label-width="100px"
      label-position="left"
      @submit.native.prevent
    >
      <el-row>
        <el-col :span="12">
          <!-- <img :src="form.simg" style="text-align: left; width: 400px" /> -->
          <!-- <div style="text-align: left; font-size: 20px">
            图片请使用Filezila等ftp工具上传
          </div>
          <div style="text-align: left; font-size: 20px">
            注意请直接上传图片，不要压缩！
          </div> -->

          <div class="block" style="margin-left: 0px; margin-right: 20px">
            <span class="demonstration" width="100%"></span>
            <el-carousel
              width="300px"
              height="1200px"
              indicator-position="outside"
              arrow="always"
            >
              <el-carousel-item
                v-for="(img, index) in form.imgList"
                :key="index"
              >
                <img :src="img.url" width="100%" />
              </el-carousel-item>
            </el-carousel>
          </div>
        </el-col>
        <el-col :span="12" class="readonly">
          <el-form-item label="书号">
            <el-input v-model="form.skuno" readonly></el-input>
          </el-form-item>
          <el-form-item label="ISBN" v-if="false">
            <el-input v-model="form.skuisbn" readonly></el-input>
          </el-form-item>
          <el-form-item label="书名：">
            <el-input v-model="form.skuname" readonly></el-input>
          </el-form-item>
          <el-form-item label="作者：">
            <el-input v-model="form.sauthor" readonly></el-input>
          </el-form-item>
          <el-form-item label="定价">
            <el-input v-model="form.ssprice" readonly></el-input>
          </el-form-item>
          <el-form-item label="出版社">
            <el-input v-model="form.spubname" readonly></el-input>
          </el-form-item>
          <el-form-item label="出版日期">
            <el-input v-model="form.spubdate" readonly></el-input>
          </el-form-item>
          <el-form-item label="套书名">
            <el-input v-model="form.tsmc" readonly></el-input>
          </el-form-item>
          <el-form-item label="大类">
            <el-input v-model="form.dlmc" readonly></el-input>
          </el-form-item>
          <el-form-item label="中类">
            <el-input v-model="form.zlmc" readonly></el-input>
          </el-form-item>
          <el-form-item label="小类">
            <el-input v-model="form.xlmc" readonly></el-input>
          </el-form-item>
          <el-form-item label="内容简介">
            <el-input
              type="textarea"
              :rows="4"
              v-model="form.skucontent"
              readonly
            ></el-input>
          </el-form-item>

          <el-form-item label="作者生平">
            <el-input
              type="textarea"
              :rows="4"
              v-model="form.sauthorlife"
              readonly
            ></el-input>
          </el-form-item>

          <el-form-item label="关键字">
            <el-input v-model="form.skukey" readonly></el-input>
          </el-form-item>

          <!-- <el-form-item label="中图分类码">
            <el-input v-model="form.sztflm" readonly></el-input>
          </el-form-item> -->

          <el-form-item label="开本号">
            <el-input v-model="form.skuformatno" readonly></el-input>
          </el-form-item>
          <el-form-item label="总页数">
            <el-input v-model="form.skupagetotal" readonly></el-input>
          </el-form-item>
          <el-form-item label="装帧">
            <el-input v-model="form.skuedition" readonly></el-input>
          </el-form-item>
          <el-form-item label="更新日期">
            <el-input v-model="form.supdateDate" readonly></el-input>
          </el-form-item>
          <el-form-item label="库存">
            <el-input v-model="form.isckc" readonly></el-input>
          </el-form-item>
          <el-form-item>
            <el-checkbox v-model="form.xdl" disabled>限大陆</el-checkbox>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="2"></el-col>
        <el-col :span="6">
          <el-button @click="putcart()" type="text" style="font-size: 30px"
            >放入购物车</el-button
          >
        </el-col>
        <el-col :span="6">
          <el-button @click="seecart()" type="text" style="font-size: 30px"
            >查看购物车</el-button
          >
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import axios from "axios";
import global from "../global.vue";
import AES from "../AES.js";

export default {
  props: ["skupackobj"],
  data() {
    return {
      num: 1,
      sremark: "",
      //public文件夹路径
      publicPath: process.env.BASE_URL,

      form: {
        skuid: "aaa",
        skuno: "bbb",
        skuname: "ccc",
        ssprice: "111",
        sauthor: "ddd",
        publisherid: "eee",
        spublishername: "fff",
        spubdate: "2020-20-20",
        dldm: "",
        dlmc: "ggg",
        zldm: "",
        zlmc: "hhh",
        xldm: "",
        xlmc: "iii",
        tsmc: "jjj",
        sztflm: "",
        simg: "/CP15112300000005.jpg",
        imgList: [
          {
            url: "./CP16062000003405_b01.jpg",
          },
          {
            url: "./CP16062000003405_b02.jpg",
          },
          {
            url: "./CP16062000003405_b03.jpg",
          },
          {
            url: "./CP16062000003405_b04.jpg",
          },
        ],
      },
    };
  },
  created() {
    this.getdata();
  },
  methods: {
    putcart() {
      this.$message({
        showClose: true,
        message: this.form.skuname + "正在添加到购物车",
        type: "success",
      });

      global.putchartifnull(this.form);
    },
    seecart() {
      console.log(window.localStorage.getItem("stoken"));
      this.$router.push({
        path: "/qtindex/shoppingcart",
      });
    },
    getProxyImageUrl(imageUrl) {
      // 将原始图片URL作为参数传递给后端代理接口
      const encodedUrl = encodeURIComponent(imageUrl);
      return global.sserverip + `imageProxy?url=${encodedUrl}`;
    },
    getdata() {
      console.log("this.skupackobj");
      console.log(this.skupackobj);
      this.form = this.skupackobj;
      console.log("form" + this.form);
      if (this.form.xdl == "T") {
        this.form.xdl = true;
      } else {
        this.form.xdl = false;
      }

      this.form.simg = "/bookpic/" + this.form.skuid + ".jpg";
      var iL = [];

      var img0 = new Object();
      // img0.url = "/bookpic/" + this.form.skuid + ".jpg";
      var img1 = new Object();
      var img2 = new Object();
      var img3 = new Object();
      var img4 = new Object();
      var img5 = new Object();
      var img6 = new Object();
      const OSS = require("ali-oss");

      const client = new OSS({
        // yourRegion填写Bucket所在地域。以华东1（杭州）为例，yourRegion填写为oss-cn-hangzhou。
        region: "oss-cn-shenzhen",
        // 阿里云账号AccessKey拥有所有API的访问权限，风险很高。强烈建议您创建并使用RAM用户进行API访问或日常运维，请登录RAM控制台创建RAM用户。
        // accessKeyId: "LTAI5tH9SH4e5qtqJHnVjsBt",
        // accessKeySecret: "Cd2kt7cqH852L1mVpKH70o30H2VWOd",        
        accessKeyId: "LTAI5t9Cq1hP2BXbWgKrBZ9C",
        accessKeySecret: "j1oVbzolFd98AQ1RtnvwcKYLqKYntN",
        // 填写Bucket名称。
        bucket: "xibcbookpic",
      });

      // 获取下载exampleobject.txt文件的签名URL，使用浏览器访问时默认直接预览要下载的文件。
      // 填写不包含Bucket名称在内的Object完整路径。
      /*
     var sImgPath =
        global.convertToEmptyString(this.form.img3Dcover) +
        global.convertToEmptyString(this.form.img3D) +
        global.convertToEmptyString(this.form.imgcopyright) +
        global.convertToEmptyString(this.form.imgback) +
        global.convertToEmptyString(this.form.imgcover) +
        global.convertToEmptyString(this.form.wonderfulimg) +
        global.convertToEmptyString(this.form.WonderfulPage);
      console.log("sImgPath = " + sImgPath);
      if (sImgPath.trim() == "") { 
      */

      if (this.form.skuid.substring(0,3) == "hgs") {
        console.log("取化工社数据");
        /*
        img0 = {
          //    url: this.getProxyImageUrl("https://res.cip.com.cn/Open/GetImage?cd=J463300&tp=script&h=0&w=0")
          url: "https://res.cip.com.cn/Open/GetImage?cd=J463300&tp=script&h=0&w=0",        };        iL.push(img0);
        */
        if (this.form.img3Dcover == "") {
        } else {
          img0 = {
            url: this.form.img3Dcover,
          };
          iL.push(img0);
        }
        if (this.form.img3D == "") {
        } else {
          img1 = {
            url: this.form.img3D,
          };
          iL.push(img1);
        }
        if (this.form.imgcopyright == "") {
        } else {
          img2 = {
            url: this.form.imgcopyright,
          };
          iL.push(img2);
        }
        if (this.form.imgback == "") {
        } else {
          img3 = {
            url: this.form.imgback,
          };
          iL.push(img3);
        }
        if (this.form.imgcover == "") {
        } else {
          img4 = {
            url: this.form.imgcover,
          };
          iL.push(img4);
        }
        if (this.form.wonderfulimg == "") {
        } else {
          img5 = {
            url: this.form.wonderfulimg,
          };
          iL.push(img5);
        }
        if (this.form.WonderfulPage == "") {
        } else {
          img6 = {
            url: this.form.WonderfulPage,
          };
          iL.push(img6);
        }
      } else {
        console.log("取自有数据");
        var url = client.signatureUrl(this.form.skuid + ".jpg");

        console.log(url);
        img0.url = url;
        iL.push(img0);

        // img0.url = "HTTPS://xibcbookpic.oss-cn-shenzhen.aliyuncs.com/" + this.form.skuid + ".jpg"
        //         +"?OSSAccessKeyId=LTAI5tH9SH4e5qtqJHnVjsBt****&Expires=1141889120&Signature=Cd2kt7cqH852L1mVpKH70o30H2VWOd****"
        //       ;
        // console.log(img0.url);

        // iL.push(img0);
        // var img1 = new Object();
        // img1.url = "/bookpic/" + this.form.skuid + "_b01.JPG";
        // iL.push(img1);

        // var img2 = new Object();
        // img2.url = "/bookpic/" + this.form.skuid + "_b02.JPG";
        // iL.push(img2);
        // var img3 = new Object();
        // img3.url = "/bookpic/" + this.form.skuid + "_b03.JPG";
        // iL.push(img3);
        // var img4 = new Object();
        // img4.url = "/bookpic/" + this.form.skuid + "_b04.JPG";
        // iL.push(img4);
        // var img5 = new Object();
        // img5.url = "/bookpic/" + this.form.skuid + "_b05.JPG";
        // iL.push(img5);
        // var img6 = new Object();
        // img6.url = "/bookpic/" + this.form.skuid + "_b06.JPG";
        // iL.push(img6);

        var url1 = client.signatureUrl(this.form.skuid + "_b01.jpg");
        img1.url = url1;
        iL.push(img1);
        var url2 = client.signatureUrl(this.form.skuid + "_b02.jpg");
        img2.url = url2;
        iL.push(img2);
        var url3 = client.signatureUrl(this.form.skuid + "_b03.jpg");
        img3.url = url3;
        iL.push(img3);
        var url4 = client.signatureUrl(this.form.skuid + "_b04.jpg");
        img4.url = url4;
        iL.push(img4);
        var url5 = client.signatureUrl(this.form.skuid + "_b05.jpg");
        img5.url = url5;
        iL.push(img5);
        var url6 = client.signatureUrl(this.form.skuid + "_b06.jpg");
        img6.url = url6;
        iL.push(img6);
      }
      this.form.imgList = iL;

      console.log(this.form);
    },
  },
};
</script>

<style>
.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 150px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #ffffff;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #ffffff;
}

.el-checkbox__input.is-disabled.is-checked .el-checkbox__inner:after {
  border-color: #092a6d;
}
.el-checkbox__input.is-disabled + span.el-checkbox__label {
  color: #09155c;
}
</style>